import styled from 'styled-components';

const InputLabelWrapper = styled.span`
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  font-weight: bold;
`;

export default InputLabelWrapper;
